module.exports = __webpack_public_path__ + "static/media/Filter.a17ea606.svg";